/* Shared line icons for services, keyed by service id (see src/data/services.js). */
const paths = {
  gbp: (
    <>
      <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  maps: (
    <>
      <path d="m3 6 5-3 8 3 5-3v15l-5 3-8-3-5 3V6Z" />
      <path d="M8 3v15M16 6v15" />
    </>
  ),
  "website-builder": (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18M8 4v5" />
    </>
  ),
  "patient-management": <path d="M3 12h4l2.5-6 4 12 2.5-6H21" />,
  "dialysis-inventory": (
    <>
      <path d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5Z" />
      <path d="M4 7.5 12 12l8-4.5M12 12v9" />
    </>
  ),
  "pathology-lab": (
    <>
      <path d="M9 3h6M10 3v7L6 17a2 2 0 0 0 1.8 3h8.4A2 2 0 0 0 18 17l-4-7V3" />
      <path d="M7.5 14.5h9" />
    </>
  ),
  "school-management": (
    <>
      <path d="M22 10v6M2 10l10-5 10 5-10 5Z" />
      <path d="M6 12v5c3 2 9 2 12 0v-5" />
    </>
  ),
  "pharmacy-management": (
    <>
      <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" />
      <path d="M8.5 8.5 15.5 15.5" />
    </>
  ),
};

export default function ServiceIcon({ id, className }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      {paths[id]}
    </svg>
  );
}
